/**
 * Retour afgerond buiten het portaal (sessie 186): redenen, regel en route.
 * Los van het paneel, zodat lijst en dossier hetzelfde gebruiken.
 */
import { retourenV3Api } from "@/lib/retouren-v3-api";
import type { RetourV3Dossier, RetourV3Groep, RetourV3StandCode } from "@/lib/retouren-v3-api";

export type BuitenPortaalReden =
  | "terugbetaald_met_de_hand"
  | "afgehandeld_in_lightspeed"
  | "vervallen"
  | "anders";

export const BUITEN_PORTAAL_REDENEN: { sleutel: BuitenPortaalReden; label: string }[] = [
  { sleutel: "terugbetaald_met_de_hand", label: "Terugbetaald met de hand" },
  { sleutel: "afgehandeld_in_lightspeed", label: "Afgehandeld in Lightspeed" },
  { sleutel: "vervallen", label: "Vervallen" },
  { sleutel: "anders", label: "Anders" },
];

/** Gelijk aan TOELICHTING_MAX in de dienst. */
export const TOELICHTING_MAX = 200;

export const BUITEN_PORTAAL_LABEL = "Afgerond buiten het portaal";

/** Mag deze retour nog buiten het portaal afgerond worden? Verlopen mag ook. */
export function kanBuitenPortaal(groep: RetourV3Groep, stand: RetourV3StandCode): boolean {
  return groep !== "afgerond" || stand === "verlopen";
}

export function rondAfBuitenPortaal(
  retourId: string,
  invoer: { reden: BuitenPortaalReden; toelichting: string | null },
): Promise<RetourV3Dossier> {
  return retourenV3Api.afgerondBuitenPortaal(retourId, invoer);
}
